import * as React from "react";

import { IDayCell_MonthMobile, IDayCellSlot_MonthMobile } from "../../../classes/dayCell_MonthMobile";

import { IEvent } from "../../../classes/event";

import { EventTooltip } from "./EventTooltip";
import * as utils from "./ListViewUtils";

import * as dates from "../../../reducers/changeTimePeriod";

import { displayEventDetails, redirectToEventDetails } from "../../Common/buttonEvents";

export interface IMonthListEventAnchorProps {
    event: IEvent;
    allDayText: string;
    eventText: string;
    toText: string;
    contextId: number;
    selectedDate: Date;
    pageId: number;
    parentId: number;
    portalId: number;
    portletInstanceId: number;
    todaysDate: Date;
    thisDate: Date;
    userDateFormat: string;
    viewMode: string;
    includeTooltip?: boolean;
    useSingleDayDescription: boolean;
    onStartAjaxCall: (event: any) => any;
    onSetEventId: (event: any) => any;
    onSetEventScreenMode: (eventScreenMode: string) => any;
    onSetiCalStartDate: (event: any) => any;
    onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
    onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
}

export const MonthListEventAnchor = (props: IMonthListEventAnchorProps) => {

    const event = props.event;
    const eventTime = dates.eventDescriptionMobile_Preformatted(event, props.allDayText, props.thisDate);
    const screenReaderDescription = dates.eventDescription_DailyList_ScreenReader(event, props.allDayText, props.thisDate, props.eventText, props.toText, event.name);
    const anchorId = event.anchorId;
    const eventID = event.eventID;
    const iCalStartDate = event.localStartDate;

    const onSetEventId = () => {
        props.onSetEventId(eventID);
    };

    const onSetEventScreenModeToView = () => {
        props.onSetEventScreenMode("VIEW");
    };

    const onSetiCalStartDate = () => {
        props.onSetiCalStartDate(iCalStartDate);
    };

    const onSetDisplayedEventLocalStartDate = () => {
        props.onSetDisplayedEventLocalStartDate(event.localStartDate);
    };

    const onSetDisplayedEventLocalEndDate = () => {
        props.onSetDisplayedEventLocalEndDate(event.localEndDate);
    };

    return (
        // <li className="CAL-EV-Item" onClick={(e) => redirectToEventDetails(e, eventID, eventReference, contextId, selectedDate, todaysDate, pageId, parentId, portalId, portletInstanceId, viewMode, onStartAjaxCall)}>
        <li className="CAL-EV-Item" onClick={(e) => displayEventDetails(e, eventID, onSetEventId, onSetEventScreenModeToView, onSetiCalStartDate, onSetDisplayedEventLocalStartDate, onSetDisplayedEventLocalEndDate)}>
            { /* Have to use dangerouslySetHTML because React inline style objects do not support !important. */}
            <a href="#!" id={anchorId}>
                {event.color &&
                    <style dangerouslySetInnerHTML={{ __html: `#${anchorId} { background: ${event.color} !important; }` }} />
                }
                <strong aria-hidden="true">
                    {event.icon &&
                        <img src={event.icon} aria-hidden="true" />
                    }                       
                    {props.event.name}
                </strong>
                <em aria-hidden="true">{eventTime}</em>
                <span className="offScreen">{screenReaderDescription}</span> 
            </a>
            {props.includeTooltip &&
                <EventTooltip allDayText={props.allDayText} event={event} theDate={props.thisDate} useSingleDayDescription={true}/>
            }
        </li>
    );
};
